import { AbstractControl } from "@angular/forms";

export const numberValidator = (control: AbstractControl): { invalidNumber: boolean } | null => {
	const val = control.value as number | string;

	if (val === null || val === "") return null;

	if (!val?.toString()?.match(/^[0-9]+(\.?[0-9]+)?$/)) return { invalidNumber: true };

	return null;
};
